export const CurrencyFormat = (value: number, currency: string): string => {
	return Intl.NumberFormat("en-US", {
		style: "currency",
		currency: currency
	}).format(value);
};
